// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var Email = function (x) {
    return x;
};
var tsBridgeEmail = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("Email")("__brandEmail"));
    }
};
var writeEmail = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showEmail = Data_Show.showString;
var readEmail = Simple_JSON.readString;
var ordEmail = Data_Ord.ordString;
var newtypeEmail = {
    Coercible0: function () {
        return undefined;
    }
};
var makeEmail = Email;
var eqEmail = Data_Eq.eqString;
export {
    Email,
    makeEmail,
    unwrap,
    newtypeEmail,
    eqEmail,
    ordEmail,
    showEmail,
    readEmail,
    writeEmail,
    tsBridgeEmail
};
//# sourceMappingURL=index.js.map
